import { render, staticRenderFns } from "./SiteDocumentEditForm.vue?vue&type=template&id=624fd663&"
import script from "./SiteDocumentEditForm.vue?vue&type=script&lang=js&"
export * from "./SiteDocumentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports